module.exports = __webpack_public_path__ + "8b4faa7382b3595e30793b6d4ccb9e81.svg";